import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { Toast } from 'antd-mobile-v5'
import CardPopupWrapper from '../../pages/BuyCards/components/CardPopupWrapper'
import BuyOptions from '../../pages/BuyCards/BuyOptions'
import { CARD_TYPE_PLASTIC, getSkuInfo } from '../../pages/BuyCards/cardOptionUtils'
import { getEcards } from '../../reducers/selectors'
import { cardStories } from '../../utils/cardStories'
import { useAddToCart } from '../../services/hooks'
import styles from './Cart.module.css'

const GoodsPopup = ({
  setVisible,
  visible,
  imageUrl,
  cardOptions,
  cartItem,
  cart,
  setCart,
  setChecked,
  checkedList,
}) => {
  const [selectedCerts, setSelectedCerts] = useState([cartItem.ecardId])
  const [isPlastic, setIsPlastic] = useState(
    cartItem.type === 'STANDARD_PHYSICAL' || cartItem.typeName === CARD_TYPE_PLASTIC
  )
  const { ecards } = useSelector((state) => ({
    ecards: getEcards(state),
  }))
  const { run: addToCartSubmit } = useAddToCart({
    onSuccess: (data) => {
      setCart(data)
      Toast.show({ icon: 'success', content: '购物车已更新' })
      setVisible(false)
    },
  })

  // 条目身份键：slim（服务端购物车：title/type）与 rich（本地重建：styleName/typeName）
  // 同构归一，跨形态排重/定位共用
  const entryKey = (item) => `${item.ecardId}|${item.title ?? item.styleName}|${item.type ?? item.typeName}`

  const updateCart = () => {
    let newCart = [...cart]
    const ecard = ecards.find((cert) => cert.encodedId === selectedCerts[0])
    const skuInfo = getSkuInfo(ecard, cardOptions, cartItem.title || cartItem.styleName, isPlastic)
    // SKU 未匹配（陈旧缓存缺 cardRequestType 等异常数据）时保持原购物车不变：
    // 防御解构 undefined 抛 TypeError（React 16 不捕获事件处理器异常）
    if (!skuInfo) return newCart
    const currentStory = cardStories.find((s) => (cartItem.title || cartItem.styleName) === s.name)
    const description = currentStory?.author?.name || null
    const { cardRequestType, ecardType, imageUrl, goodsId, skuId, ...sku } = skuInfo
    const certSku = {
      ecardId: ecard.encodedId,
      description,
      ecardName: ecard.ecardName,
      goodsId,
      skuId,
      ...sku,
    }
    // 排重：新选组合与原条目内容一致则不更新
    if (entryKey(certSku) === entryKey(cartItem)) {
      return newCart
    }
    newCart = newCart.filter((item) => entryKey(item) !== entryKey(certSku))
    // 替换新数据
    const replaceIndex = newCart.findIndex((item) => entryKey(item) === entryKey(cartItem))
    if (replaceIndex === -1) {
      newCart.unshift(certSku)
    } else {
      newCart.splice(replaceIndex, 1, certSku)
    }

    // 排重选中状态
    let newCheckedList = checkedList
    newCheckedList = newCheckedList.filter((c) => entryKey(c) !== entryKey(certSku))
    // 删除选中状态中的原数据
    newCheckedList = newCheckedList.filter((item) => entryKey(item) !== entryKey(cartItem))
    // 新增更新商品的选中状态
    newCheckedList.push(certSku)
    setChecked(newCheckedList)
    return newCart
  }

  const updateGoodsItem = () => {
    if (!selectedCerts.length > 0) {
      Toast.show({ content: '请选择证书。' })
      return
    }
    const newCart = updateCart()
    addToCartSubmit(newCart)
  }

  return (
    <CardPopupWrapper
      setVisible={setVisible}
      visible={visible}
      imageUrl={imageUrl}
      name={cartItem.title || cartItem.styleName}
      authorName={cartItem.description}
    >
      <div className={styles['options-wrapper']}>
        <BuyOptions
          mode={'dark'}
          selectedImage={cartItem.title || cartItem.styleName}
          isPlastic={isPlastic}
          setIsPlastic={setIsPlastic}
          setSelectedCerts={setSelectedCerts}
          selectedCerts={selectedCerts}
          singleCert={true}
        />
      </div>
      <div className={styles['update-btn']} onClick={updateGoodsItem}>
        <div className={styles.strong}>更新商品</div>
      </div>
    </CardPopupWrapper>
  )
}

export default GoodsPopup
